import BrandLogo from '../BrandLogo.vue';
import { helpPath } from '../../navigation';

export default {
  props: { menuItems: { type: Array, default: () => [] } },
  components: { BrandLogo },
  data: () => ({ intervalId: null }),
  computed: {
    user() {
      return this.$store.state.user;
    },
    userAvatar() {
      return (this.user && this.user.full_name ? this.user.full_name : '')
        .split(' ')
        .filter(Boolean)
        .map(x => x[0])
        .slice(0, 2)
        .join('');
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    approved() {
      return this.$store.getters.isApproved;
    },
    extranet() {
      return this.$store.state.settings.extranet === true;
    },
    helpPath() {
      return helpPath(this.user);
    },
    cartCount() {
      return this.$store.getters.cartCount;
    },
    newMobileNotifications() {
      return this.$store.state.mobileNotifications.notificationsNew || [];
    },
    unreadTickets() {
      if (!this.user) return 0;
      return this.$store.state.tickets.tickets.reduce(
        (count, ticket) => count
          + (ticket.messages || []).filter(
            message => message.readed === 0 && message.profile_id !== this.user.profile_id,
          ).length,
        0,
      );
    },
    profileID() {
      return this.user && this.user.profile_id;
    },
  },
  watch: {
    '$vuetify.breakpoint.lgAndUp': function closeDesktopDrawer(desktop) {
      if (desktop) this.SetSidebar(false);
    },
    profileID: {
      immediate: true,
      handler(id) {
        clearInterval(this.intervalId);
        if (!id) return;
        this.$store.dispatch('mobileNotifications/GetNotifications', id).catch(() => {});
        this.loadTickets(id);
        this.intervalId = setInterval(() => {
          this.refreshProfile();
          this.loadTickets(id);
        }, 60000);
      },
    },
    sidebar(value, previous) {
      if (previous && !value && !this.$vuetify.breakpoint.lgAndUp) {
        this.$nextTick(() => {
          if (this.$refs.menuButton) this.$refs.menuButton.$el.focus();
        });
      }
    },
  },
  methods: {
    refreshProfile() {
      if (this.isAuthenticated) this.$store.dispatch('GetProfile').catch(() => {});
    },
    loadTickets(id) {
      this.$store.dispatch('tickets/GetTickets', id).catch(() => {});
    },
    SetSidebar(value) {
      this.$store.dispatch('app/SetSidebar', value);
    },
    UserLogout() {
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
  },
  mounted() {
    window.addEventListener('focus', this.refreshProfile);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.refreshProfile);
    clearInterval(this.intervalId);
  },
};
